import { loadState } from 'core/utils/statePersistence'

const getCultureCountry = () => {
  const { configuration } = loadState()

  if (configuration) {
    const { campaign } = configuration
    if (campaign) {
      const { lang } = campaign
      if (lang) return lang.split('-')[1]
      return null
    }
    return null
  }
  return null
}

export default getCultureCountry
